// Main widgets
import mainFeature from './js/widgets/mainFeature.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget';
import hotButtons from './js/widgets/hotButtons.js';
import sponsorsWidget from './js/widgets/sponsorsWidget.js';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// Misc
import customFeatureLineUp from './js/featureLineUp.js';
import './js/localjs.js';

// Widgets
$(document).ready(function () {
  if (window.location.pathname !== '/') {
    customFeatureLineUp();
  } else {
    AOS.init({
      anchorPlacement: 'bottom-bottom',
      animatedClassName: 'aos-animate',
      initClassName: 'aos-init',
    });

    mainFeature();
    seoWidget();
    cardsWidget();
    multiScheduleFeature();
    $(window).load(function () {
      socialNetworkWidget.facebookfeed(true);
    });
    hotButtons();
    sponsorsWidget();
  }
});
